/** A delivery refused because its From domain is disabled; `domain` is null when nothing names it. */
export type DisabledDomainReason = { domain: string | null };

// Text from services `account_sending_domains.SendingDisabledReasonFor`; both must stay in step.
const DISABLED_DOMAIN_REASON = /^Sending from (?:this domain|(\S+)) has been disabled\. Contact support for details\.$/;
const ADDRESS_DOMAIN = /@([^\s@<>]+)>?\s*$/;

/** Matches a disabled-domain reason, taking the domain from it or else from the From address. */
export function disabledDomainReason(reason: unknown, fromAddress?: string | null): DisabledDomainReason | null {
  if (typeof reason !== 'string') return null;
  const match = DISABLED_DOMAIN_REASON.exec(reason.trim());
  if (match == null) return null;
  return { domain: match[1] ?? ADDRESS_DOMAIN.exec(fromAddress ?? '')?.[1] ?? null };
}
